import { BaseService } from 'core/services';
import FacilityScheduleRouteService from './FacilityScheduleRouteService';

class FacilityScheduleService extends BaseService {
    constructor(apiClient) {
        super(apiClient, new FacilityScheduleRouteService());
    }
}

export default FacilityScheduleService;
